import * as snapStrategyConst from './constants';
import * as commonRegionService from '../../services/common/region';

export default {
    [snapStrategyConst.getSnapStrategy](state, list) {
        var res = list.AutoSnapshotPolicySet;
        _.map(res, (item) => {
            item.AutoSnapshotDate = _.invoke(item.AutoSnapshotDate, 'sort');
            item.AutoSnapshotTime.sort((a, b) => a - b);
            var toBool = function(v) { return v === true || v === 1 || v === '1' || v === 'true'; };
            item.IsActivated = toBool(item.IsActivated);
            item.EnableCrossRegionCopy = toBool(item.EnableCrossRegionCopy);
        });
        state.list = res;
        state.total = (list.AutoSnapshotPolicySet || []).length;
    },
    [snapStrategyConst.validateSnapStra](state, val) {
        state.StraValidate = val.validate;
        state.MaxStraNum = val.AutoSnapshotPolicyInVolumeNum;
    },
    [snapStrategyConst.uniqRequestRegion](state, data) {
        state.uniqRequestRegion = data;
    }
}
